/**
 * Utility functions for ad handling
 */

/**
 * Constants for ad-related operations
 */
export const AD_CONSTANTS = {
  ETHICAL_AD_CLASS: 'ethical-ad',
  HIDDEN_CLASS: 'hidden',
  MS_PER_MINUTE: 60000,
  MS_PER_SECOND: 1000,
};

/**
 * Check if an element is visible in the DOM
 * @param {HTMLElement} element - The element to check
 * @returns {boolean}
 */
export function isElementVisible(element) {
  return element.offsetWidth > 0 && element.offsetHeight > 0;
}

/**
 * Check if enough time has passed since the last ad view
 * @param {string} adNameKey - Key to check in localStorage
 * @param {number} timeoutInMinutes - Timeout in minutes
 * @returns {boolean} - True if enough time has passed
 */
export function checkAdTiming(adNameKey, timeoutInMinutes) {
  try {
    const timeoutInMS = timeoutInMinutes * AD_CONSTANTS.MS_PER_MINUTE;
    const currentDate = new Date();
    const lastViewedStr = localStorage.getItem(adNameKey);
    
    if (!lastViewedStr) return true;
    
    const lastViewedDate = new Date(lastViewedStr);
    return currentDate.getTime() - lastViewedDate.getTime() > timeoutInMS;
  } catch (error) {
    console.error('Error checking ad timing:', error);
    return true; // Default to showing ad on error
  }
}

/**
 * Update the last viewed date for an ad
 * @param {string} adNameKey - Key to update in localStorage
 */
export function updateAdViewDate(adNameKey) {
  try {
    localStorage.setItem(adNameKey, new Date().toUTCString());
  } catch (error) {
    console.error('Error updating ad view date:', error);
  }
}

/**
 * Create a mutation observer for ad-related DOM changes
 * @param {HTMLElement} targetNode - Node to observe
 * @param {Function} callback - Callback function
 * @returns {MutationObserver}
 */
export function createAdObserver(targetNode, callback) {
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, { 
    attributes: false, 
    childList: true, 
    subtree: true 
  });
  return observer;
}
